// Hướng dẫn sử dụng — i18n fragment (song ngữ, parity vi↔en).
// Bắt đầu với hướng dẫn đăng Pin Pinterest; sẽ bổ sung nền tảng khác sau.
const fragment = {
  vi: {
    'guide.pinterest.title': 'Hướng dẫn đăng Pin Pinterest',
    'guide.pinterest.subtitle':
      'Làm theo 5 bước để kết nối tài khoản và đăng Pin đầu tiên của bạn.',
    'guide.pinterest.heroCta': 'Tạo Pin ngay',
    'guide.pinterest.stepsTitle': 'Các bước thực hiện',
    'guide.pinterest.stepsSubtitle': 'Từ kết nối tài khoản đến khi Pin được đăng.',

    'guide.pinterest.connect.title': 'Bước 1 — Kết nối tài khoản Pinterest',
    'guide.pinterest.connect.desc':
      'Vào "Tài khoản Pinterest" → "Thêm", bấm "Đăng nhập Pinterest" và cấp quyền. Hệ thống chỉ nhận mã uỷ quyền an toàn, không lưu mật khẩu của bạn.',
    'guide.pinterest.connect.cta': 'Kết nối tài khoản',

    'guide.pinterest.board.title': 'Bước 2 — Tạo hoặc chọn bảng (board)',
    'guide.pinterest.board.desc':
      'Mỗi Pin phải thuộc một bảng. Mở chi tiết tài khoản để tạo bảng mới, hoặc bạn có thể chọn bảng có sẵn ngay khi tạo Pin.',
    'guide.pinterest.board.cta': 'Xem tài khoản & bảng',

    'guide.pinterest.createPin.title': 'Bước 3 — Tạo Pin',
    'guide.pinterest.createPin.desc':
      'Vào "Bài viết Pinterest" → "Tạo Pin". Chọn tài khoản và bảng, tải ảnh lên (1 ảnh tạo Pin thường, từ 2–5 ảnh tự động thành carousel), rồi nhập tiêu đề, mô tả và đường dẫn đích.',
    'guide.pinterest.createPin.cta': 'Tạo Pin',

    'guide.pinterest.mode.title': 'Bước 4 — Chọn chế độ đăng',
    'guide.pinterest.mode.desc':
      'Lưu nháp để chỉnh sau, lên lịch để hệ thống tự đăng đúng giờ, hoặc đăng ngay lập tức. Lịch đăng tối thiểu cách hiện tại 5 phút.',

    'guide.pinterest.manage.title': 'Bước 5 — Quản lý & theo dõi',
    'guide.pinterest.manage.desc':
      'Ở "Bài viết Pinterest" bạn xem trạng thái từng Pin (nháp / đã lên lịch / đã đăng / lỗi), đổi giờ đăng, đăng ngay, sửa hoặc xoá. Pin đã đăng có link mở thẳng trên Pinterest.',
    'guide.pinterest.manage.cta': 'Mở danh sách bài viết',

    'guide.pinterest.tipsTitle': 'Mẹo để Pin hiệu quả hơn',
    'guide.pinterest.tip1': 'Dùng ảnh dọc tỉ lệ 2:3 (vd 1000×1500px) — hiển thị đẹp nhất trên Pinterest.',
    'guide.pinterest.tip2': 'Tiêu đề ngắn gọn, tối đa 100 ký tự; mô tả tối đa 800 ký tự kèm từ khoá.',
    'guide.pinterest.tip3': 'Thêm "Đường dẫn" để Pin dẫn người xem về trang sản phẩm/bài viết của bạn.',
    'guide.pinterest.tip4': 'Điền "Mô tả ảnh (alt text)" cho Pin một ảnh để tốt cho SEO và người khiếm thị.',
    'guide.pinterest.tip5': 'Lên lịch vào khung giờ người dùng hoạt động để tăng tương tác.',

    'guide.pinterest.faqTitle': 'Câu hỏi thường gặp',
    'guide.pinterest.faq1.q': 'Vì sao Pin của tôi ở trạng thái "Lỗi"?',
    'guide.pinterest.faq1.a':
      'Thường do token Pinterest hết hạn hoặc ảnh/board không hợp lệ. Hãy kiểm tra thông báo lỗi, kết nối lại tài khoản nếu cần, rồi bấm "Đăng ngay" để thử lại.',
    'guide.pinterest.faq2.q': 'Khác nhau giữa Pin thường và carousel?',
    'guide.pinterest.faq2.a':
      'Tải 1 ảnh sẽ tạo Pin thường; tải 2–5 ảnh sẽ tự động thành carousel (Pin nhiều ảnh). Hệ thống tự nhận biết theo số ảnh, bạn không cần chọn.',
    'guide.pinterest.faq3.q': 'Pin đã lên lịch được đăng như thế nào?',
    'guide.pinterest.faq3.a':
      'Hệ thống có tác vụ chạy mỗi phút, tự đăng các Pin tới hạn. Nếu lỗi tạm thời, hệ thống sẽ tự thử lại tối đa 3 lần.',
    'guide.pinterest.faq4.q': 'Tôi có thể sửa Pin đã đăng không?',
    'guide.pinterest.faq4.a':
      'Pin đã đăng lên Pinterest không sửa được trong hệ thống. Bạn chỉ có thể sửa Pin ở trạng thái nháp, đã lên lịch hoặc lỗi.',
  },
  en: {
    'guide.pinterest.title': 'How to publish a Pinterest Pin',
    'guide.pinterest.subtitle':
      'Follow 5 steps to connect your account and publish your first Pin.',
    'guide.pinterest.heroCta': 'Create a Pin',
    'guide.pinterest.stepsTitle': 'Step-by-step',
    'guide.pinterest.stepsSubtitle': 'From connecting an account to a published Pin.',

    'guide.pinterest.connect.title': 'Step 1 — Connect a Pinterest account',
    'guide.pinterest.connect.desc':
      'Go to "Pinterest accounts" → "Add", click "Sign in with Pinterest" and grant access. The system only receives a secure authorization code and never stores your password.',
    'guide.pinterest.connect.cta': 'Connect account',

    'guide.pinterest.board.title': 'Step 2 — Create or pick a board',
    'guide.pinterest.board.desc':
      'Every Pin must belong to a board. Open the account detail to create a new board, or simply pick an existing board while creating the Pin.',
    'guide.pinterest.board.cta': 'View accounts & boards',

    'guide.pinterest.createPin.title': 'Step 3 — Create the Pin',
    'guide.pinterest.createPin.desc':
      'Go to "Pinterest posts" → "Create Pin". Choose the account and board, upload images (1 image makes a standard Pin; 2–5 images become a carousel automatically), then add a title, description and destination link.',
    'guide.pinterest.createPin.cta': 'Create Pin',

    'guide.pinterest.mode.title': 'Step 4 — Choose a publish mode',
    'guide.pinterest.mode.desc':
      'Save a draft to edit later, schedule it for auto-publishing, or publish right away. Scheduled time must be at least 5 minutes from now.',

    'guide.pinterest.manage.title': 'Step 5 — Manage & track',
    'guide.pinterest.manage.desc':
      'In "Pinterest posts" you can see each Pin\'s status (draft / scheduled / published / failed), reschedule, publish now, edit or delete. Published Pins have a link that opens them on Pinterest.',
    'guide.pinterest.manage.cta': 'Open posts list',

    'guide.pinterest.tipsTitle': 'Tips for better Pins',
    'guide.pinterest.tip1': 'Use vertical 2:3 images (e.g. 1000×1500px) — they look best on Pinterest.',
    'guide.pinterest.tip2': 'Keep titles short (max 100 chars); descriptions up to 800 chars with keywords.',
    'guide.pinterest.tip3': 'Add a "Link" so the Pin drives viewers to your product/article page.',
    'guide.pinterest.tip4': 'Fill in "Alt text" for single-image Pins — good for SEO and accessibility.',
    'guide.pinterest.tip5': 'Schedule Pins for when your audience is active to boost engagement.',

    'guide.pinterest.faqTitle': 'Frequently asked questions',
    'guide.pinterest.faq1.q': 'Why is my Pin in the "Failed" state?',
    'guide.pinterest.faq1.a':
      'Usually the Pinterest token expired or the image/board is invalid. Check the error message, reconnect the account if needed, then click "Publish now" to retry.',
    'guide.pinterest.faq2.q': 'Difference between a standard Pin and a carousel?',
    'guide.pinterest.faq2.a':
      'Uploading 1 image creates a standard Pin; 2–5 images become a carousel automatically. The system detects this by image count — no need to choose.',
    'guide.pinterest.faq3.q': 'How are scheduled Pins published?',
    'guide.pinterest.faq3.a':
      'A background job runs every minute and auto-publishes due Pins. On a temporary failure it retries up to 3 times.',
    'guide.pinterest.faq4.q': 'Can I edit a published Pin?',
    'guide.pinterest.faq4.a':
      'Published Pins cannot be edited from the system. You can only edit Pins in draft, scheduled or failed state.',
  },
};

export default fragment;
